export const locations = [
  { value: 'WORKSHOP', name: 'location.WORKSHOP' },
  { value: 'SHOP', name: 'location.SHOP' },
  { value: 'SAT', name: 'location.SAT' },
];
